import { Component } from "@angular/core";
import { JoiFile } from "globals/store/files.model";
import { ShareWrapper } from "./share-wrapper.component";
import { Asset, ShareAssetData } from 'globals/store/assets.data';
import { environment } from "../../../environments/environment";
import { ActivatedRoute } from "@angular/router";
import { getNumberFromText } from "../../helpers/helpers";
import { BrandingData } from "globals/store/publish.data";
import { BrandingWrapperComponent } from "src/app/components/branding/branding-wrapper.component";
import { MutatingInputComponent } from "src/app/components/joi-input/mutating-input.component";
import { JoiInputComponent } from "src/app/components/joi-input/joi-input.component";
import { ToggleTabComponent } from "src/app/components/buttons/toggle-tab.component";
import { CommonModule } from "@angular/common";
import { PrettyNumbersPipe } from "src/app/services/pipes/prettyNumbers.pipe";


@Component({
    selector: 'share-new-asset',
    template: ` 
<branding-wrapper 
  [brandingData]="brandingData" 
  [style.--sitebackground]="brandingData?.template?.sitebackground || '#ffffff'">
  <div class="share-presentation-asset">
    <div *ngIf="loading" class="loading">Loading...</div>
    <div *ngIf="!loading && !data?.eventTitle"  class="sorry" [innerHTML]="helpers.strWithBreak(helpers.strWithBreak('The assets submission area is currently not available.\n\nPlease contact the event organiser.'))"></div>
    <div *ngIf="submitted"  class="thanks" [innerHTML]="helpers.strWithBreak(resultMessage)"></div>
    <div class="container" *ngIf="!!data?.eventTitle && !submitted">
      <h1>{{ data.eventTitle }}</h1>
      <div *ngIf="data.adderName" class="performer_name">
        {{ asset.submitterType }}: {{ data.adderName }}
      </div>
      <div class="instructions">
        Please update asset information
      </div>
      <div class="note">
        Note: This form will be deactivated after you submit. Ensure you have finished modifying your asset before submitting.
      </div>

      <mutating-input 
        *ngIf="!data.adderName" 
        [object]="submitterForAnyone" 
        prop="name" 
        placeholder="Your name"
        (textChange)="checkValidity(); changed = true;"
      ></mutating-input>
      <mutating-input 
        [object]="asset" 
        [prop]="'name'" 
        [placeholder]="'Asset name'"
        (textChange)="checkValidity(); changed = true;"
      ></mutating-input>
      <div class="quantity-holder">
        <div class="quantity">Asset Quantity:</div>
        <joi-input 
          [(model)]="asset.quantity" 
          [fixedWidth]="true"
          [placeholder]="'Number...'"
          [outlined]="true"
          [displayValue]="asset.quantity ? (asset.quantity | prettyNumbers:2:1:false:true) : null"
          [allowableCharacters]="'0123456789.'"
          [disabled]="false"
          (joiChange)="updateQuantity()"
        ></joi-input>
      </div>
      <mutating-input 
        [object]="asset" 
        [prop]="'description'" 
        [placeholder]="'Asset Information'"
        (textChange)="checkValidity(); changed = true;"
      ></mutating-input>
      <mutating-input 
        [object]="asset" 
        [prop]="'link'" 
        [placeholder]="'Full URL (Must start with http or https)'"
        [error]="!linkValid ? 'URL must start with http:// or https://' : null"
        (textChange)="checkValidity(); changed = true;"
      ></mutating-input>
      <div class="actions-holder">
        <button mat-button color="primary" (click)="submit()" [disabled]="processing || !changed" >
          <div class="button_content">
            Submit
          </div>
        </button>
        <div style="flex:1;"></div>
        <toggle-tab
          [bottomTab]="false"
          [borderless]="true"
          [text]="asset.ready ? 'Ready' : 'Not Ready'" 
          [toggled]="asset.ready" 
          (toggle)="asset.ready = !asset.ready; checkValidity(); changed = true;"
        ></toggle-tab>
      </div>

      <div class="error-holder" *ngIf="error" [innerHTML]="helpers.strWithBreak(error)"></div>
    </div>
  </div>
</branding-wrapper>
  `,
    styleUrls: ['./share.editPerformer.scss', '../assets/manage-assets.scss'],
    styles: [`
    .actions-holder { display: flex; align-items: center; }
  `],
    standalone: true,
    imports: [BrandingWrapperComponent, MutatingInputComponent, JoiInputComponent, ToggleTabComponent, CommonModule, PrettyNumbersPipe]
})
export class ShareNewAssetComponent extends ShareWrapper<ShareNewAssetComponent> {

  readonly api = `${environment.functionsURL}api/v1`; // NOTE this is pointing to api/v1 not api/app
  id:string;
  eventId: string
  data: ShareAssetData
  processing:boolean;
  loading: boolean
  disabled = true
  submitted:boolean;
  changed = false
  linkValid = true
  asset: Asset = {}
  submitterForAnyone = { name: '' }
  cannotSubmitMessage = "The assets can't be submitted at this time.\n\nPlease reload this page and try again."
  resultMessage = "Thank you"
  brandingData: BrandingData

  constructor(private route:ActivatedRoute) {
    super()
    this.loading = true;
    document.title = "loading";
    this.route.params.subscribe(params=>{
      if(!params || !params.hasOwnProperty('id')) {
        this.loading = false;
        document.title = "Unavailable";
      } else {
        const { id, eventId } = params;
        this.id = id
        this.eventId = eventId
        console.log({ id, eventId })
        const url = `${this.api}/load-share-asset-data`
        this.take1(this.http.post(url, { id, eventId })).then((data: ShareAssetData) => {
          this.loading = false
          this.data = data
          this.asset = data.asset
          this.brandingData = data.brandingData
          console.log({ data })
          document.title = "Upload asset"
        }, (response) => {
          this.loading = false;
          document.title = "Unavailable";
        });
      }
    })
  }

    
  updateQuantity() {
    this.asset.quantity = getNumberFromText(this.asset.quantity, 0)
  }

  submit(){
    this.processing = true;
    this.asset.updatedBy = this.data.adderName || this.submitterForAnyone.name
    this.take1(this.http.post(`${this.api}/submit-asset`, { asset: this.asset, eventId: this.eventId })).then((data:any) => {
      this.processing = false;
      this.submitted = true;
    }, error => {
      console.error({ error })
      this.processing = false;
      this.showError(this.cannotSubmitMessage)
    });
  }

  get inactiveMessage() {
    return `The asset submission area is currently not available.\n\nPlease contact the event organiser.`
  }

  getFreshFile(): JoiFile{
    return {
      filename:'',
      linkUrl:'',
      created: (new Date()).getTime(),
    }
  }
  

  isValid() {
    this.linkValid = !this.asset.link || this.helpers.urlOk(this.asset.link)
    return !!this.asset.name && this.linkValid
  }

  checkValidity(invalid = false) {
    this.disabled = !this.isValid() || (!this.data.adderName && !this.submitterForAnyone.name)
  }





}
